import { render, staticRenderFns } from "./Sharing.vue?vue&type=template&id=6e726b10&"
import script from "./Sharing.vue?vue&type=script&lang=js&"
export * from "./Sharing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e726b10')) {
      api.createRecord('6e726b10', component.options)
    } else {
      api.reload('6e726b10', component.options)
    }
    module.hot.accept("./Sharing.vue?vue&type=template&id=6e726b10&", function () {
      api.rerender('6e726b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/atoms/Sharing/Sharing.vue"
export default component.exports